<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <h2 class="my-2">給餌機一覧</h2>
            </v-col>
            <v-col class="text-right mt-3">
                <v-btn small color="success" @click="openDlgClick(0)"><h3>追加</h3></v-btn>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbFeeders" :key="obj.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ obj.name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h4>管理番号：{{ obj.sort_no }}</h4>
                        <h4>飼料名：{{ obj.pellet }}</h4>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(obj.id)"><h3>編集</h3></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgFeeder.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-10">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field label="管理番号" v-model="dlgFeeder.sort_no" outlined dense type="number" hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field label="名前" v-model="dlgFeeder.name" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-switch inset v-model="dlgFeeder.m1sensor" label="モータ1回転検出"></v-switch>
                                <v-switch inset v-model="dlgFeeder.m2sensor" label="モータ2回転検出"></v-switch>
                                <v-switch inset v-model="dlgFeeder.loadcell" label="ロードセル使用"></v-switch>
                                <v-switch inset v-model="dlgFeeder.is_react" label="自発センサー"></v-switch>
                                <v-switch inset v-model="dlgFeeder.stock_sensor" label="飼料残量センサー"></v-switch>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field label="飼料名" v-model="dlgFeeder.pellet" outlined dense hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-text-field label="限度量(kg/日)" v-model="dlgFeeder.day_max" outlined dense type="number" hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量1 (kg/分)" v-model="dlgFeeder.output1" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量2 (kg/分)" v-model="dlgFeeder.output2" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量3 (kg/分)" v-model="dlgFeeder.output3" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量4 (kg/分)" v-model="dlgFeeder.output4" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量5 (kg/分)" v-model="dlgFeeder.output5" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量6 (kg/分)" v-model="dlgFeeder.output6" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量7 (kg/分)" v-model="dlgFeeder.output7" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量8 (kg/分)" v-model="dlgFeeder.output8" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field label="吐出量9 (kg/分)" v-model="dlgFeeder.output9" outlined dense type="number" step="0.001" :disabled="usingPlan(dlgFeeder.id)"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <div class="text-right red--text" v-show="usingPlan(dlgFeeder.id)">給餌プランで利用中のためロックされています</div>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="3">
                                            <v-text-field label="エサ残量 (Full)" v-model="dlgFeeder.stock_high" outlined dense type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field label="エサ残量 (Mid)" v-model="dlgFeeder.stock_mid" outlined dense type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field label="エサ残量 (Low)" v-model="dlgFeeder.stock_low" outlined dense type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field label="エサ残量 (Empty)" v-model="dlgFeeder.stock_empty" outlined dense type="number"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-container>
                        <v-row class="mb-8">
                            <v-col class="text-center pa-0" v-show="dlgFeeder.id > 0">
                                <v-btn color="error" @click="showDelDlg = true" width="100" :disabled="usingPlan(dlgFeeder.id)">削除</v-btn>
                            </v-col>
                            <v-col class="text-center pa-0">
                                <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                            </v-col>
                            <v-col class="text-center pa-0">
                                <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showDelDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark>確認</v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgFeeder.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" class="float-left" @click="axiosDelete()">削除！</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="success" outlined @click="showDelDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
export default {
    name: "Feeders",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            showEditDlg: false,
            showDelDlg: false,
            isLoading: false,
            dbFeeders: [],
            dbFeedPlans: [],
            dlgFeeder: {
                id: 0,
                site_id: 0,
                name: "PFX-3000",
                sort_no: 999,
                pellet: "pellet-01",
                day_max: 100,
                output1: 1.0,
                output2: 2.0,
                output3: 3.0,
                output4: 4.0,
                output5: 5.0,
                output6: 6.0,
                output7: 7.0,
                output8: 8.0,
                output9: 9.0,
                stock_high: 263,
                stock_mid: 337,
                stock_low: 447,
                stock_empty: 1017,
                m1sensor: false,
                m2sensor: false,
                loadcell: false,
                is_react: false,
                stock_sensor: false,
            },
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------------------------------
        //非同期でAxiosGet
        const promiseFeeder = this.axiosGetFeeders();
        const promiseFeedPlans = this.axiosGetFeedPlans();
        //-----------------------
        //上記の終了を待つ
        await promiseFeeder;
        await promiseFeedPlans;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------
        this.isLoading = false;
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    methods: {
        //===================================================
        async axiosGetFeeders() {
            await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeeders = response.data.json;
            });
        },
        //===================================================
        // 給餌プランDataを取得
        //===================================================
        async axiosGetFeedPlans() {
            await this.axios({
                method: "GET",
                url: "/web/api/feed_plans",
                headers: { Authorization: "Bearer " + this.jwt },
                params: {
                    _fields: "id,device_id,feeder_id",
                    //device_id: this.device_id
                },
                timeout: 30000,
            }).then((response) => {
                this.dbFeedPlans = response.data.json;
            });
        },
        //===================================================
        // 給餌プランで、既に使用されているか？
        //===================================================
        usingPlan(feeder_id) {
            let useCounter = 0;
            for (let obj of this.dbFeedPlans) {
                if (obj.feeder_id == feeder_id) useCounter++;
            }
            return useCounter > 0 ? true : false;
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            //-----------------------------
            if (primaryKey) {
                for (let obj of this.dbFeeders) {
                    if (obj.id == primaryKey) {
                        this.dlgFeeder = JSON.parse(JSON.stringify(obj));
                        let option_json = this.dlgFeeder["option_json"] ? JSON.parse(this.dlgFeeder["option_json"]) : {};
                        this.dlgFeeder["m1sensor"] = option_json["m1sensor"] ? option_json["m1sensor"] : false;
                        this.dlgFeeder["m2sensor"] = option_json["m2sensor"] ? option_json["m2sensor"] : false;
                        this.dlgFeeder["loadcell"] = option_json["loadcell"] ? option_json["loadcell"] : false;
                        this.dlgFeeder["stock_sensor"] = option_json["stock_sensor"] ? option_json["stock_sensor"] : false;

                        this.dlgFeeder["output1"] = (this.dlgFeeder["output1"] / 1000).toFixed(3);
                        this.dlgFeeder["output2"] = (this.dlgFeeder["output2"] / 1000).toFixed(3);
                        this.dlgFeeder["output3"] = (this.dlgFeeder["output3"] / 1000).toFixed(3);
                        this.dlgFeeder["output4"] = (this.dlgFeeder["output4"] / 1000).toFixed(3);
                        this.dlgFeeder["output5"] = (this.dlgFeeder["output5"] / 1000).toFixed(3);
                        this.dlgFeeder["output6"] = (this.dlgFeeder["output6"] / 1000).toFixed(3);
                        this.dlgFeeder["output7"] = (this.dlgFeeder["output7"] / 1000).toFixed(3);
                        this.dlgFeeder["output8"] = (this.dlgFeeder["output8"] / 1000).toFixed(3);
                        this.dlgFeeder["output9"] = (this.dlgFeeder["output9"] / 1000).toFixed(3);
                    }
                }
            } else {
                this.dlgFeeder["id"] = 0;
                this.dlgFeeder["name"] = "新規 給餌機";
                this.dlgFeeder["sort_no"] = "100";
                this.dlgFeeder["pellet"] = "ペレット001";
                this.dlgFeeder["day_max"] = 100;
                this.dlgFeeder["output1"] = 1.5;
                this.dlgFeeder["output2"] = 2.5;
                this.dlgFeeder["output3"] = 3.5;
                this.dlgFeeder["output4"] = 4.5;
                this.dlgFeeder["output5"] = 5.5;
                this.dlgFeeder["output6"] = 6.5;
                this.dlgFeeder["output7"] = 7.5;
                this.dlgFeeder["output8"] = 8.5;
                this.dlgFeeder["output9"] = 9.5;
                this.dlgFeeder["stock_high"] = 263;
                this.dlgFeeder["stock_mid"] = 337;
                this.dlgFeeder["stock_low"] = 447;
                this.dlgFeeder["stock_empty"] = 1017;
                this.dlgFeeder["m1sensor"] = false;
                this.dlgFeeder["m2sensor"] = false;
                this.dlgFeeder["loadcell"] = false;
                this.dlgFeeder["is_react"] = false;
                this.dlgFeeder["stock_sensor"] = false;
                delete this.dlgFeeder["modified"];
            }
            this.showEditDlg = true;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgFeeder["name"]) ErrCount++;
            if (!this.dlgFeeder["sort_no"]) ErrCount++;
            if (!this.dlgFeeder["pellet"]) ErrCount++;
            if (!this.dlgFeeder["day_max"]) ErrCount++;
            if (!this.dlgFeeder["output1"]) ErrCount++;
            if (!this.dlgFeeder["output2"]) ErrCount++;
            if (!this.dlgFeeder["output3"]) ErrCount++;
            if (!this.dlgFeeder["output4"]) ErrCount++;
            if (!this.dlgFeeder["output5"]) ErrCount++;
            if (!this.dlgFeeder["output6"]) ErrCount++;
            if (!this.dlgFeeder["output7"]) ErrCount++;
            if (!this.dlgFeeder["output8"]) ErrCount++;
            if (!this.dlgFeeder["output9"]) ErrCount++;
            if (!this.dlgFeeder["stock_high"]) ErrCount++;
            if (!this.dlgFeeder["stock_mid"]) ErrCount++;
            if (!this.dlgFeeder["stock_low"]) ErrCount++;
            if (!this.dlgFeeder["stock_empty"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            const axiosData = JSON.parse(JSON.stringify(this.dlgFeeder));
            axiosData["site_id"] = this.myInfo.site_id;

            axiosData["output1"] = Math.floor(axiosData["output1"] * 1000);
            axiosData["output2"] = Math.floor(axiosData["output2"] * 1000);
            axiosData["output3"] = Math.floor(axiosData["output3"] * 1000);
            axiosData["output4"] = Math.floor(axiosData["output4"] * 1000);
            axiosData["output5"] = Math.floor(axiosData["output5"] * 1000);
            axiosData["output6"] = Math.floor(axiosData["output6"] * 1000);
            axiosData["output7"] = Math.floor(axiosData["output7"] * 1000);
            axiosData["output8"] = Math.floor(axiosData["output8"] * 1000);
            axiosData["output9"] = Math.floor(axiosData["output9"] * 1000);

            axiosData["option_json"] = JSON.stringify({
                m1sensor: this.dlgFeeder.m1sensor,
                m2sensor: this.dlgFeeder.m2sensor,
                loadcell: this.dlgFeeder.loadcell,
                stock_sensor: this.dlgFeeder.stock_sensor,
            });
            axiosData["is_react"] = axiosData["is_react"] ? "1" : "0";
            delete axiosData["m1sensor"];
            delete axiosData["m2sensor"];
            delete axiosData["loadcell"];
            delete axiosData["stock_sensor"];
            delete axiosData["modified"];
            //-----------------------------------
            const primaryKey = this.dlgFeeder.id;
            let restMethod = "PUT";
            if (primaryKey == 0) restMethod = "POST";

            let restUrl = "/web/api/feeders";
            if (primaryKey > 0) restUrl = restUrl + "/" + primaryKey;

            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            })
                .then(() => {
                    this.axiosGetFeeders();
                })
                .catch(function (error) {
                    if (error.response.data.err == "ER_DUP_ENTRY") {
                        alert("重複しています。\n保存できません。");
                    } else {
                        alert("ん？ " + error.response.data.err);
                    }
                });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosDelete() {
            this.showDelDlg = false;
            this.showEditDlg = false;
            this.isLoading = true;
            //-------------------------
            const PrimaryKey = this.dlgFeeder.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/feeders/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.axiosGetFeeders();
            });
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
    },
    //========================================================
};
</script>
